import { Anchor, Box, Button, LoadingOverlay, Paper, Stack, Text, Title } from "@mantine/core";
import React from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import * as yup from "yup";
import { AuthApi, GeneralApi } from "../../apis";
import { ReactComponent as EraLogo } from "../../assets/logo.svg";
import { Form } from "../../components/form";
import { PasswordField } from "../../components/form/password-field";
import { TextField } from "../../components/form/text-field";
import { authChange, authMe } from "../../store/Auth";
import { initGeneral } from "../../store/General";
import { Message } from "../../utils/message";
import classes from "./auth-split.module.css";

const schema = yup.object({
  username: yup.string().required("Хэрэглэгчийн нэрээ оруулна уу").trim(),
  password: yup.string().required("Нууц үгээ оруулна уу"),
});

type IForm = {
  username: undefined | string;
  password: undefined | string;
};

export default function Login() {
  const [loading, setLoading] = React.useState<boolean>(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [data] = React.useState<IForm>({
    username: "",
    password: "",
  });

  const onSubmit = async (values: IForm) => {
    setLoading(true);
    try {
      const payload = {
        ...values,
        type: "STAFF",
      };
      const res = await AuthApi.login(payload);
      dispatch(authChange(res));

      const auth = await AuthApi.me();
      const resInit = await GeneralApi.init();

      dispatch(authMe(auth));
      dispatch(initGeneral(resInit));

      navigate("/");
      Message.success("Амжилттай нэвтэрлээ");
      setLoading(false);
    } catch (error: any) {
      Message.error(error?.message);
      setLoading(false);
    }
  };

  return (
    <Box className={classes.root}>
      <Box className={classes.brand}>
        <Box className={classes.brandMark}>
          <EraLogo className={classes.brandLogo} />
          <Box>
            <Text className={classes.brandName}>DeHUB</Text>
            <Text className={classes.brandSub}>платформ</Text>
          </Box>
        </Box>

        <Box className={classes.brandCopy}>
          <Text className={classes.eyebrow}>Dehub.MN платформын Back Office</Text>
          <Title order={1} className={classes.welcome}>
            Тавтай морилно уу!
          </Title>
          <Text className={classes.description}>
            DeHUB платформд бүртгэлтэй компаниудын бүртгэл, хяналт, гэрээний харилцаа болон админ эрхийн тохиргоо хийх, платформ дээр ашиглагдах лавлах
            мэдээллүүдийг бүртгэх, тохируулах, дотоод хэрэглэгчдийн бүртгэл, эрхийн тохиргоо
          </Text>
        </Box>
      </Box>

      <Box className={classes.form}>
        <Paper withBorder shadow="md" radius="lg" pos="relative" className={classes.card}>
          <LoadingOverlay visible={loading} />
          <Stack gap="lg">
            <Box className={classes.cardLogo}>
              <EraLogo className={classes.cardLogoMark} />
              <Box>
                <Text className={classes.cardLogoName}>DeHUB</Text>
                <Text className={classes.cardLogoSub}>платформ</Text>
              </Box>
            </Box>

            <Box>
              <Title order={2} fw={600} c="dark.6">
                НЭВТРЭХ
              </Title>
              <Text size="sm" c="dimmed" mt={4}>
                Бүртгэлтэй имэйл болон нууц үгээ оруулна уу.
              </Text>
            </Box>

            <Form initialValues={data} onSubmit={onSubmit} validationSchema={schema}>
              {() => {
                return (
                  <Stack gap="md">
                    <TextField
                      label="Хэрэглэгчийн нэр"
                      required
                      variant="default"
                      radius="md"
                      size="md"
                      name="username"
                      placeholder="ba***@mail.com"
                    />
                    <PasswordField label="Нууц үг" variant="default" radius="md" size="md" name="password" placeholder="Нууц үг" />

                    <Text size="sm" c="dimmed" ta="right">
                      Нууц үг ээ мартсан бол{" "}
                      <Anchor component={Link} to="/auth/forgot" fw={600} c="brand">
                        ЭНД ДАРЖ
                      </Anchor>{" "}
                      сэргээнэ үү.
                    </Text>

                    <Button type="submit" color="brand" size="md" radius="md" fullWidth mt={4}>
                      НЭВТРЭХ
                    </Button>
                  </Stack>
                );
              }}
            </Form>
          </Stack>
        </Paper>
      </Box>
    </Box>
  );
}
